var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartTypeLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 7.5,
    stroke: "var(--report-widget-icon-stroke-outer)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11 29V25L19.5 20.5L23.8333 22.8462L31 18.5V29H11Z",
    fill: "url(#paint0_linear_21795_27051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.4589L23.8333 19.647L19.6444 17.2105L11 22.2632V19.7818L19.6444 14.7404L23.8333 17.2105L31 13V15.4589Z",
    fill: "#F37321"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.4589L23.8333 24.647L19.6444 22.2105L11 27.2632V24.7818L19.6444 19.7404L23.8333 22.2105L31 18V20.4589Z",
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21795_27051",
    x1: 21,
    y1: 20.5,
    x2: 21,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--report-widget-icon-stroke-dark)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--report-widget-icon-stroke-dark)",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTypeLineIcon);
export default __webpack_public_path__ + "static/media/chart-type-line-icon.86264b64154b06416c99fea938ce3677.svg";
export { ForwardRef as ReactComponent };